import { useSelectFunnelStagesByType } from '@user/store/salesFunnel'
import {
  OwnerMenuItem,
  useGetOwnerList,
} from '@user/store/salesTeam/hooks/useGetOwnerList'
import { ENTITY_TYPES } from '@sales-center/common'

interface Props {
  salesFunnelId: number
  salesTeamId: string
  assigneeId: string | null
}

export function useData(props: Props) {
  const { salesFunnelId, salesTeamId, assigneeId } = props
  const salesFunnelStages = useSelectFunnelStagesByType(
    salesFunnelId,
    'Lead',
    true,
  )

  const ownerList: OwnerMenuItem[] = useGetOwnerList(
    ENTITY_TYPES.Lead,
    +salesTeamId,
    false,
  )

  const filteredOwners = ownerList.map((user) => ({
    id: user.id,
    fullName: user.name,
    isPosition: user.isPosition,
    level: user.level,
  }))

  const salesTeamUsers = [
    {
      id: null,
      fullName: 'Unassigned',
      isPosition: false,
      level: 0,
    },
    ...filteredOwners,
  ]

  const initialValues = {
    salesFunnelStageId:
      salesFunnelStages.find((stg) => stg.name === 'Qualify')?.id || -1,
    owner:
      assigneeId === null
        ? salesTeamUsers[0]
        : salesTeamUsers.find((user) => user.id === assigneeId) || null,
    expectedClosingDate: null,
  }

  return {
    initialValues,
    salesFunnelStages,
    owners: salesTeamUsers,
  }
}
